import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'

const mapSize = {
    XS: 'base',
    S: 'sm',
    M: 'md',
    L: 'lg',
    XL: 'xl',
}

const classNames = {
    XS: 'xsmall',
    S: 'small',
    M: 'medium',
    L: 'large',
    XL: 'xlarge',
}

const mapColor = {
    Black: 'black',
    White: 'white',
    Grey: 'grey',
}

const PaddingBlock = ({size, color}) => {
    const styles = useMultiStyleConfig('PaddingBlock', {
        size: mapSize[size],
        variant: mapColor[color],
    })

    return (
        <Box
            sx={styles}
            className={`del-padding--${classNames?.[size]}`}
            data-testid="padding-block"
        />
    )
}

PaddingBlock.propTypes = {
    size: PropTypes.oneOf(['XS', 'S', 'M', 'L', 'XL']),
    color: PropTypes.oneOf(['Black', 'White', 'Grey']),
}

export default PaddingBlock
